// Tier 2 fallback: recognizes any real-world city name Mapli has no
// `cities` doc for at all, so the search can say "coming soon" instead of
// "no matches". Same Maps JS API key already used client-side in
// newBusinessPages/components/myLocations.js.
const GOOGLE_MAPS_API_KEY = "AIzaSyBzqNdOb1GQUpeP2bFfsed64Yp_hEALAQ4";

let loadPromise = null;

function loadGoogleMaps() {
  if (window.google?.maps?.places) return Promise.resolve(window.google);
  if (loadPromise) return loadPromise;

  loadPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places`;
    script.async = true;
    script.onload = () => resolve(window.google);
    script.onerror = () => reject(new Error("Failed to load Google Maps JS API"));
    document.head.appendChild(script);
  });

  return loadPromise;
}

export async function newSessionToken() {
  const google = await loadGoogleMaps();
  return new google.maps.places.AutocompleteSessionToken();
}

// Predictions from AutocompleteService carry no coordinates — need a
// separate Place Details call to check real inventory near a Tier-2 pick.
export async function getPlaceLocation(placeId, sessionToken) {
  const google = await loadGoogleMaps();
  const service = new google.maps.places.PlacesService(document.createElement("div"));
  return new Promise((resolve) => {
    service.getDetails({ placeId, sessionToken, fields: ["geometry"] }, (result, status) => {
      if (status !== google.maps.places.PlacesServiceStatus.OK || !result?.geometry?.location) {
        resolve(null);
        return;
      }
      resolve({ lat: result.geometry.location.lat(), lng: result.geometry.location.lng() });
    });
  });
}

export async function getCityPredictions({ input, sessionToken, language }) {
  if (!input) return [];
  const google = await loadGoogleMaps();
  const service = new google.maps.places.AutocompleteService();

  return new Promise((resolve) => {
    service.getPlacePredictions({ input, types: ["(cities)"], sessionToken, language }, (predictions, status) => {
      if (status !== google.maps.places.PlacesServiceStatus.OK || !predictions) {
        resolve([]);
        return;
      }
      resolve(
        predictions.map((p) => ({
          placeId: p.place_id,
          name: p.structured_formatting?.main_text || p.description,
          secondary: p.structured_formatting?.secondary_text || "",
        })),
      );
    });
  });
}
